module.exports = __webpack_public_path__ + "static/media/pulsidBracelet.dd3a28d2.webp";